/**
 * Copies text to the clipboard
 * @param text - Text to copy to clipboard
 * @returns Promise that resolves when text is copied, rejects on error
 */
export const copyToClipboard = async (text: string): Promise<void> => {
  await navigator.clipboard.writeText(text)
}
